import React from 'react';
import styled from 'styled-components';
import boxes from '../assets/images/bbb-boxes.png';

const BoxImages = (): JSX.Element => {
  return (
    <BoxImagesWrapper>
      <Image />
    </BoxImagesWrapper>
  );
};

const BoxImagesWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

const Image = styled.div`
  background-image: url(${boxes});
  background-size: cover;
  background-position: calc(100% - 55%) center;
  height: 100%;
  width: 100%;
`;

export default BoxImages;
